var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 151.844,
    height: 151.844,
    rx: 75.922,
    fill: "#ECF5F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.616 44H74.9531V99.5752H77.616V44Z",
    fill: "#09081A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.281 100.91C75.9349 100.91 75.6153 100.777 75.349 100.537L52.9805 78.8079L54.8445 76.8906L76.281 97.7147L97.3447 76.8906L99.2088 78.7813L77.2131 100.511C76.9734 100.777 76.6272 100.91 76.281 100.91Z",
    fill: "#09081A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.593 105.328H50V107.991H102.593V105.328Z",
    fill: "#05D484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgDownload);
export default __webpack_public_path__ + "static/media/BgDownload.6ed3d61c.svg";
export { ForwardRef as ReactComponent };